// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tmqvJ","colBig":"styles_colBig__2sB-3","colSmall":"styles_colSmall__2THC5"};